import keys from '@debbie/common/dist/cache/keys.js';
import * as api from '../api/interaction-categories.js';
import q from '../query.js';
export const interactionCategoriesEntity = `interaction-categories`;
export const useInteractionCategories = () => q.query('interaction-categories', api.getAll, keys.read.collection(interactionCategoriesEntity));
//# sourceMappingURL=index.js.map